import Image from "next/image";

import { cn } from "@/lib/utils";

interface LogoProps {
  /** "wordmark" is the mark + "Clinic Suite 360" text; "icon" is just the circular mark, for tight spaces. */
  variant?: "wordmark" | "icon";
  className?: string;
  /** Rendered height in px; width follows the source image's aspect ratio. */
  height?: number;
}

function Logo({ variant = "wordmark", className, height = 32 }: LogoProps) {
  const src = variant === "wordmark" ? "/logo.png" : "/logo-icon.png";
  const aspectRatio = variant === "wordmark" ? 1234 / 405 : 1;
  const width = Math.round(height * aspectRatio);

  return (
    <span className={cn("inline-flex shrink-0 items-center", className)}>
      <Image
        src={src}
        alt="ClinicSuite360"
        width={width}
        height={height}
        style={{ height, width }}
        priority
        unoptimized
        className="dark:drop-shadow-[0_0_6px_rgba(255,255,255,0.55)]"
      />
    </span>
  );
}

export { Logo };
